import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const options = { role: ROLE.USER };
const path = "/user";

export const getShoplists = async (productId = null) => {
  const query = productId ? `?product_id=${productId}` : "";
  return await axiosInstance(options).get(`${path}/shoplists${query}`);
};

export const createShoplist = async (data) => {
  return await axiosInstance(options).post(`${path}/shoplists`, data);
};

export const updateShoplist = async (id, data) => {
  return await axiosInstance(options).put(`${path}/shoplists/${id}`, data);
};

export const deleteShoplist = async (id) => {
  return await axiosInstance(options).delete(`${path}/shoplists/${id}`);
};

export const toggleProductInShoplist = async (data) => {
  return await axiosInstance(options).post(`${path}/shoplists/toggle-product`, data);
};

export const getShoplistProducts = async (shoplistId) => {
  return await axiosInstance(options).get(`${path}/shoplists/products?shoplist_id=${shoplistId}`);
};
